"use client";

import React from "react";
import { MessageCircle, ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalTaxiCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section id="localtaxicta" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        <div ref={ref} style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 450ms cubic-bezier(0.16, 1, 0.3, 1), transform 450ms cubic-bezier(0.16, 1, 0.3, 1)"
      }} className="bg-[#324A6D] text-white rounded-3xl p-8 sm:p-12 md:p-16 text-center shadow-lg relative overflow-hidden">
          <div className="max-w-2xl mx-auto space-y-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-white font-default">
              Brauchen Sie ein Taxi in Hurghada?
            </h2>
            <p className="text-white/85 text-base sm:text-lg leading-relaxed font-default">
              Sichern Sie sich Ihre Fahrt ganz unkompliziert – Ihre Anfrage wird direkt von unserem Team für eine reibungslose Fahrt durch die Stadt bestätigt.
            </p>
          </div>

          <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-8 py-3.5 h-auto rounded-full text-base transition-all duration-180 shadow-sm">
              <Link to="#local-taxi-service" className="inline-flex items-center justify-center gap-2">
                <span>Lokales Taxi buchen</span>
                <ArrowUp className="size-4 shrink-0" aria-hidden="true" />
              </Link>
            </Button>

            <Button asChild className="w-full sm:w-auto bg-[#27BA2A] text-white hover:bg-[#22a025] font-medium px-8 py-3.5 h-auto rounded-full text-base transition-all duration-180 shadow-sm">
              <Link to="https://wa.me/201010634627?text=Hallo%20Hurghada%20Transfer%20Hub%2C%20ich%20m%C3%B6chte%20eine%20lokale%20Taxifahrt%20in%20Hurghada%20anfragen." newTab className="inline-flex items-center justify-center gap-2">
                <MessageCircle className="size-5 shrink-0" aria-hidden="true" />
                <span>Per WhatsApp kontaktieren</span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}